import React from 'react'
import PropTypes from 'prop-types'
import VectorImage from 'components/VectorImage'
import classnames from 'classnames'
import Snippet from './Snippet'
import downloadIcon from './images/icon_download.svg'

export default class TextBlock extends React.Component {
  static propTypes = {
    content: PropTypes.object,
    frontendId: PropTypes.string
  }

  render() {
    const {content} = this.props

    return this.renderBlockType(content)
  }

  renderBlockType(content) {
    const {frontendId} = this.props
    const type = this.getBlockType(content)
    const classNames = classnames('installation_block', `is-${type}`)

    switch (type) {
      case 'snippet':
        return (
          <div className={classNames}>
            <Snippet type={content.snippet} frontendId={frontendId} />
          </div>
        )
      case 'text':
        return (
          <div className={classNames}>
            {(content.title || content.step) &&
              <h2>{content.step && <span className='step'>Step {content.step}</span>} {content.title}</h2>
            }
            <div
              dangerouslySetInnerHTML={{
                __html: content.text.replace('YOUR_FRONTEND_ID', `<span class='frontendId'>${frontendId}</span>`)
              }}
            />
          </div>
        )
      case 'list':
        return (
          <ul className={classNames}>
            {content.list.map(item => {
              if (Array.isArray(item)) {
                return (
                  <li>
                    {item.map(block => this.renderBlockType(block))}
                  </li>
                )
              }
              return <li>{item}</li>
            })}
          </ul>
        )
      case 'title':
        return (
          <div className={classNames}>
            <h2>{content.title}</h2>
          </div>
        )
      case 'file':
        return (
          <a href={content.file} className={classNames} target={content.blank ? '_blank' : '_self'}>
            <div className='installation_block_icon'>
              <VectorImage
                width='20px'
                height='22px'
                source={downloadIcon}
              />
            </div>
            {content.title}
            {content.version ? <span>{content.version}</span> : null}
          </a>
        )
      case 'image':
        return (
          <img src={content.image} className='installation_block_image' />
        )

      default: return null
    }
  }

  getBlockType(content) {
    if (content.hasOwnProperty('text')) return 'text'
    if (content.hasOwnProperty('video')) return 'video'
    if (content.hasOwnProperty('file')) return 'file'
    if (content.hasOwnProperty('title')) return 'title'
    if (content.hasOwnProperty('image')) return 'image'
    if (content.hasOwnProperty('list')) return 'list'
    if (content.hasOwnProperty('snippet')) return 'snippet'

    return null
  }
}



// WEBPACK FOOTER //
// ./client/components/Wizard/TextBlock.js